import http from "../services/httpService";

export async function getPublishers() {
    const resp = await http.get('/publishers/');
    return resp.data;
}

export async function getBooks(subjectId, isDigital, search) {
    let url = '/books/';
    const params = [];
    if (subjectId) params.push(`subject_id=${subjectId}`);
    if (isDigital !== undefined && isDigital !== '' && isDigital !== null) params.push(`is_digital=${isDigital}`);
    if (search) params.push(`search=${search}`);
    if (params.length) url += '?' + params.join('&');
    const resp = await http.get(url);
    return resp.data;
}

export async function getBook(id) {
    const resp = await http.get(`/books/${id}/`);
    return resp.data;
}

export async function postBook(data) {
    const resp = await http.post('/books/', data);
    return resp.data;
}

export async function patchBook(data) {
    const resp = await http.patch(`/books/${data.id}/`, data);
    return resp.data;
}

export async function deleteBook(id) {
    const resp = await http.delete(`/books/${id}/`);
    return resp.data;
}

export async function postBookCode(data) {
    const resp = await http.post('/book_codes/', data);
    return resp.data;
}

export async function patchBookCode(data) {
    const resp = await http.patch(`/book_codes/${data.id}/`, data);
    return resp.data;
}

export async function deleteBookCode(id) {
    const resp = await http.delete(`/book_codes/${id}/`);
    return resp.data;
}

export async function startAssignBookCodes() {
    const resp = await http.get(`/books/assign_book_codes/`);
    return resp.data;
}

export async function getBookCodeSummary() {
    const resp = await http.get(`/books/assignment_summary/`);
    return resp.data;
}

export async function getBookCodesForStudent(studentId) {
    const resp = await http.get(`/books/student_books?student_id=${studentId}`);
    return resp.data;
}

export async function unassignBookCode(id) {
    const resp = await http.post(`/book_codes/${id}/unassign/`);
    return resp.data;
}

export async function postBookCodes(id, data) {
    const resp = await http.post(`/books/${id}/import_book_codes/`, data);
    return resp.data;
}
